import { useQuery } from '@tanstack/react-query';
import { addPreviousSearch as doAddPreviousSearch, getPreviousSearches } from '../borrowed/catalog-app/typescript/src/app/transport/api';

/**
 * Get the most recent searches done by the current user (as stored in preferences)
 */
export const useCatalogPreviousSearches = () => {
  return useQuery(['previousSearches', {}], () => getPreviousSearches(), {
    refetchOnWindowFocus: false,
    cacheTime: 60000
  });
};
export const addPreviousSearch = async search => {
  await doAddPreviousSearch(search);
};
//# sourceMappingURL=useCatalogPreviousSearches.js.map